// extracted by mini-css-extract-plugin
var _1 = "PrimaryMenu-modulePrimaryMenu__zPqXY MenuItems-moduleMenuItems__Km6SD";
export { _1 as "PrimaryMenu" }
